import { Box, Divider, Flex, Text } from '@chakra-ui/react';
import useCurrencyText from 'hooks/shared/useCurrencyText';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface GridItem {
  label: string;
  amount: number;
  currency: Currency;
}

const PortfolioBalanceInfo: FC<PortfolioBalanceInfo> = ({
  income,
  circulation,
  withdrawal,
  refill,
}) => {
  const currencyText = useCurrencyText();

  const { t } = useTranslation();

  const items: GridItem[] = [
    {
      label: t('income'),
      amount: income.amount,
      currency: income.currency,
    },
    {
      label: t('replenishment'),
      amount: refill.amount,
      currency: refill.currency,
    },
    {
      label: t('circulation'),
      amount: circulation.amount,
      currency: circulation.currency,
    },
    {
      label: t('withdrawal'),
      amount: withdrawal.amount,
      currency: withdrawal.currency,
    },
  ];

  return (
    <Flex flexWrap="wrap" justifyContent="space-between">
      {items.map((item, index) => (
        <Box key={index} w="calc(50% - 10px)">
          <Flex py="18px" alignContent="center" justifyContent="space-between">
            <Text fontWeight={600}>{item.label}</Text>
            <Text>
              {currencyText(item.amount, { symbol: item.currency.symbol })}
            </Text>
          </Flex>
          <Divider />
        </Box>
      ))}
    </Flex>
  );
};

export default PortfolioBalanceInfo;
